import { Loader2 } from "lucide-react";

// Per-row stand-in for the Workpaper(s) cell while a control's agentic match
// job is still queued or crawling. Replaces the WorkpaperChip for that row
// until the ref reaches a terminal status (matched/no_match/failed).
export const MatchingWorkpaperIndicator = () => (
  <span className="inline-flex items-center gap-1.5 text-sm text-stone-500">
    <Loader2 className="h-3.5 w-3.5 animate-spin" />
    Matching workpapers...
  </span>
);
